export type ICropImage = (
  modalBody: IjQueryElmOrHtmlElm,
  cropImageButton: IjQueryElmOrHtmlElm,
  modalImgElm: HTMLImageElement | JQuery<HTMLImageElement>,
  fileName: string,
  input: HTMLInputElement | JQuery<HTMLInputElement>,
  input64: HTMLInputElement | JQuery<HTMLInputElement>
) => void;

export function _cropImage(
  modalBody: IjQueryElmOrHtmlElm,
  cropImageButton: IjQueryElmOrHtmlElm,
  modalImgElm: HTMLImageElement | JQuery<HTMLImageElement>,
  fileName: string,
  input: HTMLInputElement | JQuery<HTMLInputElement>,
  input64: HTMLInputElement | JQuery<HTMLInputElement>
): void {
  const options = window.DexeroCoreApp.getUserOptions();
  const successCompletionMsg =
    options && options.langObj ? options.langObj.successCompletionMsgText : '';
  const waitMsg = options && options.langObj ? options.langObj.waitMsgText : '';
  const $cropImageButton = $(cropImageButton) as IjQueryElm;
  const $modalImgElm = $(modalImgElm);
  const $input = $(input);
  const $input64 = $(input64);

  // Block user elements
  window.DexeroCoreApp.animateButton($cropImageButton);
  window.DexeroCoreApp.blockUI(waitMsg, modalBody);

  // Get crop data from cropper
  const cropData = ($modalImgElm as any).cropper('getData', true);
  const cropImageHeight = cropData.height;
  const cropImageWidth = cropData.width;
  const cropCanvas = ($modalImgElm as any).cropper('getCroppedCanvas', {
    fillColor: 'white',
    height: cropImageHeight,
    width: cropImageWidth,
  });
  const imageBase64 = cropCanvas.toDataURL();
  const commaIndex = imageBase64.indexOf(',');
  const imageDataOne = imageBase64.substring(0, commaIndex);
  const imageDataTwo = imageBase64.substring(commaIndex + 1);
  const imageDataComplete = `${imageDataOne},${cropImageWidth}x${cropImageHeight},${imageDataTwo}`;

  // Since we are now submitting a base64 string instead of a image file, we empty the file upload input and populate _base64
  $input.val('');
  $input64.val(imageDataComplete);

  // Object to update image buttons
  const imageJSON = {
    downloadUrl: imageBase64,
    height: cropImageHeight,
    name: fileName,
    width: cropImageWidth,
  };

  window.DexeroCoreApp._setImageUploadButtonElms(input, imageJSON);
  window.DexeroCoreApp.animateButton($cropImageButton);
  window.DexeroCoreApp.blockUI(undefined, modalBody, true);
  window.DexeroCoreApp.userToastMsg('success', successCompletionMsg);
}
